import FormCampaign from "../campaign-form";

export const EditCampaign = () => {
  return <FormCampaign />;
};

export default EditCampaign;
